"use client";

import { c as _c } from "react/compiler-runtime";
import { SidebarContent, SidebarGroup, SidebarGroupContent, SidebarMenu } from "@/components/ui/sidebar";
import { SiteMapItem } from "@/config/sitemap";
import { SidebarNavItem } from "./sidebar-nav-item";
interface SidebarNavProps {
  menuItems: SiteMapItem[];
  currentRoute: string | undefined;
}
export function SidebarNav(t0) {
  const $ = _c(7);
  const {
    menuItems,
    currentRoute
  } = t0;
  let t1;
  if ($[0] !== currentRoute || $[1] !== menuItems) {
    let t2;
    if ($[3] !== currentRoute) {
      t2 = (item, index) => <SidebarNavItem key={item.route || `menu-item-${index}`} item={item} currentRoute={currentRoute} />;
      $[3] = currentRoute;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = menuItems.map(t2);
    $[0] = currentRoute;
    $[1] = menuItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <SidebarContent><SidebarGroup className="px-2 pl-4 pt-2"><SidebarGroupContent><SidebarMenu>{t1}</SidebarMenu></SidebarGroupContent></SidebarGroup></SidebarContent>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}